import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';

import React from 'react';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { isFulfillmentPlanStatusActionable } from '../../split-ship-modal-context-provider';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';

import { SplitShipRowFulfillmentPlanPropType } from '../../prop-types';

import style from './shipment-dropdown.module.less';
import ShipmentDropdownMenuItemLabel from './shipment-dropdown-menu-item-label';

const ShipmentDropdown = ({ disabled = false, fulfillmentPlans, onSelectFulfillmentPlan, selectedFulfillmentPlanIndex }) => {
  const isCreateNewSelected = selectedFulfillmentPlanIndex === -1;
  const selectedFulfillmentPlan = isCreateNewSelected ? {} : fulfillmentPlans[selectedFulfillmentPlanIndex];

  const createNewOptionShipmentCounter = fulfillmentPlans.length + 1;
  const selectedItemShipmentCounter = isCreateNewSelected ? createNewOptionShipmentCounter : selectedFulfillmentPlanIndex + 1;

  return (
    <DropdownMenu className={style['dropdown-menu']} disabled={disabled} dropdownMenuShouldHaveWidthOfButton variant='form'>
      <DropdownMenuToggler>
        <ShipmentDropdownMenuItemLabel
          isCreatesNewOption={isCreateNewSelected}
          isNew={selectedFulfillmentPlan.isNew}
          shipmentCounter={selectedItemShipmentCounter}
        />
      </DropdownMenuToggler>
      {fulfillmentPlans.map((fulfillmentPlan, index) => (
        <DropdownMenuItem
          key={fulfillmentPlan.fulfillmentPlanId}
          className={style['dropdown-menu-item']}
          disabled={!isFulfillmentPlanStatusActionable(fulfillmentPlan.orderGridStatus)}
          onClick={() => onSelectFulfillmentPlan(fulfillmentPlan.fulfillmentPlanId)}
        >
          <ShipmentDropdownMenuItemLabel isNew={fulfillmentPlan.isNew} shipmentCounter={index + 1} />
          {fulfillmentPlan.fulfillmentPlanId === selectedFulfillmentPlan.fulfillmentPlanId && (
            <FontAwesomeIcon className={style.icon} icon={faCheck} />
          )}
        </DropdownMenuItem>
      ))}
      <DropdownMenuItem className={style['dropdown-menu-item']} disabled={disabled} onClick={() => onSelectFulfillmentPlan(undefined)}>
        <ShipmentDropdownMenuItemLabel isCreatesNewOption shipmentCounter={createNewOptionShipmentCounter} />
        {isCreateNewSelected && <FontAwesomeIcon className={style.icon} icon={faCheck} />}
      </DropdownMenuItem>
    </DropdownMenu>
  );
};

ShipmentDropdown.propTypes = {
  selectedFulfillmentPlanIndex: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  onSelectFulfillmentPlan: PropTypes.func.isRequired,
  fulfillmentPlans: PropTypes.arrayOf(SplitShipRowFulfillmentPlanPropType).isRequired,
};

export default React.memo(ShipmentDropdown);
